
import { useMessage, useNotification } from 'naive-ui'
import { defineComponent, watchEffect } from 'vue'
import { _notifications, _toasts } from '../utils/notification.util';

export default defineComponent({
  setup() {
    const message = useMessage();
    const notification = useNotification();
    watchEffect(() => {
      if (_notifications.value && _notifications.value.length) {
        const notif = _notifications.value.pop();
        if (notif) {
          notification.create(notif);
        }
      } else if(_toasts.value && _toasts.value.length) {
        const toast = _toasts.value.pop();
        if(toast) {
          message[toast.type](toast.title, {
            duration: toast.duration === null ? 3000 : toast.duration
          });
        }
      }
    });
  }
})
